module.exports = __webpack_public_path__ + "img/right-arrow.124de25c.svg";